module.exports = __webpack_public_path__ + "static/img/shangpinguanli.ea30f05.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shangpinguanli.gif
// module id = hK2O
// module chunks = 1